export const VisualInspectSectionDataP726 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F119VisualInspection',
                label: 'Visually inspect valve for general condition and signs of damage, external leakage, corrosion and surface contamination.',
                value: formData.F119VisualInspection,
                isRequired: true,
                isMultiline: true,
                xs: 12,
                width: '50%',
                inputWidth: '50%',
                alignItems: 'inherit',
                marginBottom: '15px'
            }]
        }
    ]

});
